
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExternalProjectLinkDtoFormGroup() {
return new FormGroup({
    localProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    tenantId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectNumber: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    sharedNotes: new FormControl<string | undefined>(''),
    externalCustomerName: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    syncSettings: new FormControl<any | undefined>(undefined),
})
;
}
      